module.exports = __webpack_public_path__ + "media/images/gift-voucher-c01d28122d3f5fc392fb779982971a8d.png";